var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showEmpty)?_c('div',[_c('NavBar'),_c('ProjectList',{attrs:{"showDrawer":"true"}}),_c('main',[_c('v-row',{staticClass:"map_edit_container"},[_c('v-col',{staticClass:"mb-30",attrs:{"cols":"12"}},[_c('ProjectEmpty')],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }